// extracted by mini-css-extract-plugin
export default {"container_bookings":"_bookings_container_bookings__lY47z"};